// extracted by mini-css-extract-plugin
export default {"rivers":"FeaturesSection-module__rivers--LRQwE"};